import { useState, useEffect } from "react";

import tournamentAPI from "api/tournaments";
import { Game } from "types/game";
import { GrossType } from "utils";

export interface PlayerTMGameType extends Game {
  holes: number[];
}

type StateType = {
  games: PlayerTMGameType[];
  isLoading: boolean;
  holes: { nett: number; gross: GrossType; holeNumber: number; par: number; score: number; gameId: string }[];
  isEclectic: boolean;
};

export const usePlayerTMGames = (playerId: string, tournamentId: string) => {
  const [state, setState] = useState<StateType>({
    games: [],
    holes: [],
    isEclectic: false,
    isLoading: false,
  });

  useEffect(() => {
    let cancelled = false;

    const getTMGames = async () => {
      setState(prevState => ({ ...prevState, isLoading: true }));
      try {
        const { data } = await tournamentAPI.getPlayerTournamentGames(playerId, tournamentId);
        if (cancelled) return;
        setState({
          games: data.data?.games ?? [],
          holes: data.data?.holes ?? [],
          isEclectic: Boolean(data.data?.isEclectic),
          isLoading: false,
        });
      } catch {
        if (cancelled) return;
        setState({ games: [], holes: [], isEclectic: false, isLoading: false });
      }
    };

    getTMGames();
    return () => {
      cancelled = true;
    };
  }, [playerId, tournamentId]);

  return state;
};
